module.exports = __webpack_public_path__ + "static/card-4-9e99e4fbe0ce0bdfdba1b2e4a395fccb.png";